module.exports = "/assets/data/581293d87f996b31ab05fce9623d6bb4-CO4.data.json";